import {TextField} from "@mui/material";
import React from "react";
import _ from "lodash";
import styles from "./styles/Styles.module.css";

export default function BasicFormTextField({input, label, id, name, disabled = false, handleChange, placeholder, type, min, max, sx, meta: { touched, error }}) {
  const hasError = touched && !_.isEmpty(error);

  return(
      <div>
        <TextField className={ hasError ? styles.textFieldError : styles.textField }
                   InputProps={{ classes: { root: styles.textField } }}
                   FormHelperTextProps={{ className: styles.helperText }}
                   inputProps={{ min: min, max: max }}
                   id={id}
                   name={name}
                   label={label}
                   variant="outlined"
                   onChange={handleChange}
                   placeholder={placeholder}
                   type={type || 'text'}
                   {...input}
                   error={ hasError }
                   sx={sx}
                   helperText={ hasError ? error : undefined }
                   disabled={disabled} />
    </div>

  )
}